import { topicsData } from '@/mocks/homeData';

const trendConfig: Record<string, { icon: string; color: string; label: string }> = {
  hot: { icon: 'ri-fire-line', color: 'text-primary-500', label: '爆' },
  up: { icon: 'ri-arrow-up-line', color: 'text-accent-500', label: '升' },
  new: { icon: 'ri-add-circle-line', color: 'text-secondary-500', label: '新' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
          热议话题
        </h2>
        <p className="text-sm text-foreground-500 mb-8">全网最热门的话题标签实时更新</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-3">
          {topicsData.map((topic) => {
            const trend = trendConfig[topic.trend];
            return (
              <a
                key={topic.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-3 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer group"
              >
                <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className={`${topic.icon} text-primary-600 text-lg`}></i>
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5 mb-0.5">
                    <span className="text-xs font-bold text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                      {topic.name}
                    </span>
                    {trend && (
                      <span className={`text-xs font-semibold ${trend.color} whitespace-nowrap`}>{trend.label}</span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-400">{topic.heat}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}